import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { BriefcaseIcon } from '@heroicons/react/24/outline';
import { Modal, ModalContent as ModalContentBase, Button as ButtonV2 } from '@restworld/ui-ds-base';
import { useAuth } from '@restworld/feature-authentication';

import { cn } from '@restworld/utils-common';
interface PaymentSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ModalContentInner = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col gap-2.5 items-center w-full text-center', className)} {...props} />
);

const Description = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <p className={cn('text-[16px] font-normal text-[#1c1c33] leading-[1.5]', className)} {...props} />
);

const ButtonsContainer = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col w-full', className)} {...props} />
);

export const PaymentSuccessModal: React.FC<PaymentSuccessModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation('payment-and-invoices');
  const router = useRouter();
  const { user } = useAuth();

  const handleManageJobPositions = React.useCallback(() => {
    onClose();
    router.push('/employer/job-positions');
  }, [onClose, router]);

  const footer = (
    <ButtonsContainer>
      <ButtonV2 variant="primary" StartIcon={BriefcaseIcon} onClick={handleManageJobPositions}>
        {t('manage_job_positions')}
      </ButtonV2>
    </ButtonsContainer>
  );

  return (
    <Modal open={isOpen} onOpenChange={(v) => !v && onClose()}>
      <ModalContentBase
        title={t('invoice_settled_successfully')}
        footer={footer}
        showCloseIcon
        className="max-w-[640px]"
      >
        <ModalContentInner>
          <Description>{t('invoice_settled_description', { name: user?.name || t('hi') })}</Description>
        </ModalContentInner>
      </ModalContentBase>
    </Modal>
  );
};

export default PaymentSuccessModal;
